import moment from "moment";
import { number } from "yup";

const formatMonthShort = (date) => {
    const newDate = moment(date).format('DD MMM YYYY'); // output: 22 May 2023 
    return newDate
}

const formatDateYMD = (date) => {
    let formatDate = moment(date).format("YYYY-MM-DD") //output: 2023-05-23
    return formatDate
}

const formatDateDMY = (date) => {
    let formatDate = moment(date).format("DD-MM-YYYY") //output: 23-05-2023
    return formatDate
}

const formatSlashDateDMY = (date) => {
    let formatDate = moment(date).format("DD/M/YYYY") //output: 23/5/2023
    return formatDate
}

const formatDateTime = (datetime) => {
    const datetimeValue = new Date(datetime);
    //return datetimeValue.toLocaleString();

    let hours = datetimeValue.getHours();
    let minutes = datetimeValue.getMinutes();
    const apm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return `${datetimeValue.toLocaleDateString()} ${hours}:${minutes}${apm}`; //output: 4/27/2023 10:16AM
};

const formatLongDate = (datetime) => {
    let today = new Date(datetime);
    let date = String(today.getDate()).padStart(2, '0');
    let month = today.toLocaleString('default', { month: 'long' });
    let year = today.getFullYear();
    let longDate = date + " " + month + " " + year;
    return longDate;
}

const parseToLocale = datetime => {
    const datetimeValue = new Date(datetime);
    // console.log(datetimeValue.getFullYear());
    // console.log(datetimeValue.getMonth());
    // console.log(datetimeValue.getDate());
    // console.log(datetimeValue.getHours() + ':00:00');
    // console.log('------- ');

    let month = datetimeValue.getMonth() + 1;
    if (month < 10) month = '0' + month;
    let date = datetimeValue.getDate();
    if (date < 10) date = '0' + date;
    let hour = datetimeValue.getHours()
    if (hour < 10) hour = '0' + hour;
    hour += ':00:00';
    return {
        datePart: `${datetimeValue.getFullYear()}-${month}-${date}`,
        timePart: hour
    };
}

const formatDate = (datetime) => {
    const datetimeValue = new Date(datetime);
    return `${datetimeValue.toLocaleDateString()}`; //output: 5/22//2023
};

const formatPhoneNumber = (number) => {
    // Remove all non-digit characters from the input
    const cleanedNumber = number.replace(/\D/g, '');

    // Define the regular expression patterns for different input formats
    const inputPatterns = [
        /^(\d{3})(\d{3})(\d{4})$/,           // Matches 01X-XXXYYYY
        /^(\d{4})(\d{4})(\d{4})$/,           // Matches 01X-XXXXYYYY
        /^01(\d{3})(\d{4})$/,                // Matches 01XXXXYYYY
        /^01(\d{4})(\d{4})$/                 // Matches 01XXXXXYYYY
    ];

    // Define the regular expression patterns for the desired formats
    const outputPatterns = [
        '$1-$2$3',                            // Output format 01X-XXXYYYY
        '$1-$2$3',                            // Output format 01X-XXXXYYYY
        '0$1-$2$3',                           // Output format 01X-XXXYYYY
        '0$1-$2$3'                            // Output format 01X-XXXXYYYY
    ];

    // Find the appropriate input pattern for the cleaned number
    const inputPatternIndex = inputPatterns.findIndex(p => p.test(cleanedNumber));

    if (inputPatternIndex !== -1) {
        // Apply the corresponding output pattern to the cleaned number and format it
        const formattedNumber = cleanedNumber.replace(inputPatterns[inputPatternIndex], outputPatterns[inputPatternIndex]);
        return formattedNumber;
    } else {
        // If no matching input pattern is found, return the original input
        return number;
    }
}

const categoryOptions = (categories) => {
    const categoryList = categories.map(c => c.category);
    return categoryList;
};

const typeOptions = (categories, category) => {
    let typeList = [];
    const selectedCategories = categories.filter(c => c.category === category);
    if (selectedCategories.length > 0) {
        typeList = selectedCategories[0].types
    }
    return typeList;
};

const countryOptions = (countries) => {
    const countryList = countries.map(c => c.country);
    return countryList;
};

const stateOptions = (stateArea) => {
    const statesList = stateArea.map(({ state }) => state);
    return statesList;
};

const areaOptions = (countryStates, state) => {
    let areaList = [];
    const selectedState = countryStates.filter(s => s.state === state);
    if (selectedState.length > 0) {
        areaList = selectedState[0].areas;
    }
    return areaList;
};

const generateKey = (len) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < len; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
};

const getUniqueString = () => { //generate unique string for new upload img key used
    return (Math.random() + 1).toString(36).substring(7);
}

const displayLoc = loc => {
    if (loc && loc.coordinates) return `[${loc.coordinates[1]},${loc.coordinates[0]}]`;
    return `[0,0]`;
};

const log = (val) => {
    if (process.env.REACT_APP_DEV_MODE === `true`)
        console.log(val);
};

const outdatedInDays = process.env.REACT_APP_OUTDATED_IN_DAYS
const subtract60Days = () => {
    let nextEndDate = new Date();
    nextEndDate.setDate(nextEndDate.getDate() - outdatedInDays);
    let nextEndDateString = nextEndDate.toISOString().slice(0, -1);
    let finalDate = new Date(nextEndDateString)
    return finalDate;
}

// Disallow the characters '-' and 'e'
const handleKeyDown = (e) => {
    if (e.key === '-' || e.key === 'e') {
        e.preventDefault();
    }
}

const applyThousandSeparator = (val) => {
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

//number formatter only can be used for string/text type, for input, pls remove the number's comma (,) before passing to API
const numberFormatter = (val, decimal, isPercentage) => {
    val = String(val)
    let newVal = "";

    const thousandSeparator = (val) => {
        if (isPercentage) return val //no thousand separator for percentage %
        return applyThousandSeparator(val);
    }

    if (decimal > 0) {
        newVal = val.replace(/[^0-9.]/g, ""); //allow decimal
        if (val.indexOf(".") === 0) { //auto add a zero if dot is typed first
            newVal = val.replace(/\./g, "0.")
        }
        if (newVal.charAt(0) === "0" && newVal.charAt(1) !== ".") {
            return newVal = "0" //prevent typing number start with zero except decimal
        }
        const dotIdx = newVal.indexOf(".")
        if (dotIdx >= 0) {
            newVal = (thousandSeparator(newVal.substring(0, dotIdx)) //numbers before dot
                + newVal.substring(dotIdx, dotIdx + 1) //dot
                + newVal.substring(dotIdx + 1, dotIdx + 1 + decimal).replace(/\./g, "")) //decimal numbers after dot (prevent typing multiple dots)
        } else newVal = thousandSeparator(newVal)
        // newVal = (dotIdx >= 0) ?
        //     (thousandSeparator(newVal.substring(0, dotIdx)) + newVal.substring(dotIdx, dotIdx + 1) 
        //     + newVal.substring(dotIdx + 1, dotIdx + 1 + decimal).replace(/\./g, ""))
        //     : thousandSeparator(newVal)
    } else {
        newVal = thousandSeparator(val.replace(/[^0-9]/g, "")) //no decimal allowed
    }
    return newVal
}

const isExpiringSoon = (expiryDate, days = 30) => {
    const expiry = new Date(expiryDate);
    if (isNaN(expiry.getTime())) {
        return false; // Handle invalid date format
    }

    const today = new Date();

    // Get timestamps at midnight for both dates
    const midnightExpiry = new Date(expiry.getFullYear(), expiry.getMonth(), expiry.getDate());
    const midnightToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    // Calculate difference in milliseconds
    const differenceInMilliseconds = midnightExpiry.getTime() - midnightToday.getTime();

    // Check if difference is within 30 days (in milliseconds)
    return differenceInMilliseconds <= 1000 * 60 * 60 * 24 * days;
}

const downloadFile = (data, filename) => {
    // Create a download link using the response data
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    // Clean up the URL object and remove the download link
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
}

const daysLeft = (expiryDate) => {
    const oneDay = 24 * 60 * 60 * 1000; // milliseconds in a day
    const expiryDateObj = new Date(expiryDate).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);
    const diffInTime = expiryDateObj - today;
    const diffInDays = Math.ceil(diffInTime / oneDay);

    return diffInDays;
}

const compareArrays = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }
    
    // Sort both arrays and compare them, so that order in array doesn't matter
    const sortedArr1 = [...arr1].sort()
    const sortedArr2 = [...arr2].sort()

    return sortedArr1.every((value, index) => value === sortedArr2[index]);
}

export default {
    formatDateYMD: formatDateYMD,
    formatDate: formatDate,
    formatPhoneNumber: formatPhoneNumber,
    formatDateTime: formatDateTime,
    formatLongDate: formatLongDate,
    parseToLocale: parseToLocale,
    categoryOptions: categoryOptions,
    typeOptions: typeOptions,
    countryOptions: countryOptions,
    stateOptions: stateOptions,
    areaOptions: areaOptions,
    generateKey: generateKey,
    getUniqueString: getUniqueString,
    displayLoc: displayLoc,
    log: log,
    formatMonthShort: formatMonthShort,
    formatDateDMY: formatDateDMY,
    formatSlashDateDMY: formatSlashDateDMY,
    subtract60Days: subtract60Days,
    handleKeyDown: handleKeyDown,
    applyThousandSeparator,
    numberFormatter: numberFormatter,
    isExpiringSoon,
    downloadFile,
    daysLeft,
    compareArrays,
}